export default class ClassDesignerLinkCommonEditorController {
	/* @ngInject */
	/**
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {any} Notification
	 */
	constructor(
		$translate,
		Notification,
	) {
		this.Notification = Notification;
		this.jsonEditorOptions = {
			mode:    'view',
			modes:   ['view'],
			onError: (/** @type {any} */ error) => {
				this.Notification.warning({
					title:     $translate.instant('error.title'),
					message:   error.toString(),
				});
			},
		};
	}
}
